import React from 'react';
import { useT } from '@repo/common';
import HeaderText from '../Common/HeaderText';
import CouponsHeaderButton from './CouponsHeaderButton';

const CouponsHeader = ({ currentFilter, onFilterChange, $isMobile }) => {
  const t = useT();

  return (
    <div className='flex w-full items-start justify-between tabletH:px-[15px]'>
      {!$isMobile && <HeaderText label={t('Coupons', '쿠폰')} />}
      <div className='flex flex-col w-full tabletH:w-auto'>
        <CouponsHeaderButton
          $isMobile={$isMobile}
          currentFilter={currentFilter}
          onFilterChange={onFilterChange}
        />
        {$isMobile && currentFilter === 'Inactive' && (
          <div className='pb-4 px-2 text-text-placeholder typo-b12'>
            {t(
              'Expired within the last 30 days.',
              '최근 30일 이내에 만료된 쿠폰입니다.'
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CouponsHeader;
